import React from 'react';
import { Main } from 'fragments';
import { PracticeFragment } from "./fragments";

export const Practice = () => {

    return (
        <Main>
            <PracticeFragment />
        </Main>
    );
};
